// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2L55I","productName":"Table_productName__JHpWa"};